const { googleMapsAPIKey } = window;

export const loadGoogleMapsAPI = callback => {
  const googleMapsScriptTag = document.createElement('script');
  const firstScriptTag = document.getElementsByTagName('script')[0];
  googleMapsScriptTag.src = `https://maps.googleapis.com/maps/api/js?v=3.0&key=${googleMapsAPIKey}&callback=${callback}`;
  firstScriptTag.parentNode.insertBefore(googleMapsScriptTag, firstScriptTag);
};

// show confirmation alert when user clicks link that is off-site
export const linkOutAlert = event => {
  const { thirdPartySites } = window;
  const { hostname } = window.location;
  const target = event.currentTarget;
  const urls = getURLSHostname(thirdPartySites);

  if (
    target != '' &&
    !target.hostname.includes(hostname) &&
    !urls.includes(target.hostname) &&
    !event.currentTarget.href.includes('tel:') &&
    !event.currentTarget.href.includes('javascript:')
  ) {
    event.preventDefault();

    const confirm = window.confirm(
      'You have clicked on a third-party link and are now leaving Velocity Credit Union’s website. You will be accessing a website over which Velocity has no control. Velocity makes no representations or warranties with respect to the information contained on the third-party site and takes no responsibility for supplementing, updating or correcting such information. Other Internet sites or services may have privacy policies or security that differ from that of Velocity Credit Union.'
    );

    if (confirm) return window.open(target.href, '_blank');
  }
};

// with the given array of URLS/Domains return an array of the hostnames
export const getURLSHostname = (urls = []) => {
  const urlArray = urls.split(',');
  const urlHostnames = urlArray.map(url => new URL(url).hostname);

  return urlHostnames;
};

export const openPopUpWindow = href =>
  window.open(
    href,
    'targetWindow',
    'left=20, top=20, width=385, height=570, toolbar=1, resizable=0'
  );
